/**
 * Pays proposés à la saisie d'un numéro de téléphone (vérification du téléphone, 2026-10-18) : ceux des trajets
 * Europe ↔ Afrique de la plateforme. Affichage seulement — le serveur contrôle le numéro et le met au format
 * international (`phonenumbers`) ; un numéro saisi avec son indicatif (+…) est accepté quel que soit le pays choisi.
 */
export const PHONE_COUNTRIES = [
  { code: 'FR', name: 'France', dial: '+33' },
  { code: 'BE', name: 'Belgique', dial: '+32' },
  { code: 'CH', name: 'Suisse', dial: '+41' },
  { code: 'LU', name: 'Luxembourg', dial: '+352' },
  { code: 'DE', name: 'Allemagne', dial: '+49' },
  { code: 'ES', name: 'Espagne', dial: '+34' },
  { code: 'IT', name: 'Italie', dial: '+39' },
  { code: 'PT', name: 'Portugal', dial: '+351' },
  { code: 'GB', name: 'Royaume-Uni', dial: '+44' },
  { code: 'CA', name: 'Canada', dial: '+1' },
  { code: 'US', name: 'États-Unis', dial: '+1' },
  { code: 'SN', name: 'Sénégal', dial: '+221' },
  { code: 'CI', name: 'Côte d’Ivoire', dial: '+225' },
  { code: 'ML', name: 'Mali', dial: '+223' },
  { code: 'BF', name: 'Burkina Faso', dial: '+226' },
  { code: 'GN', name: 'Guinée', dial: '+224' },
  { code: 'BJ', name: 'Bénin', dial: '+229' },
  { code: 'TG', name: 'Togo', dial: '+228' },
  { code: 'NE', name: 'Niger', dial: '+227' },
  { code: 'MR', name: 'Mauritanie', dial: '+222' },
  { code: 'CM', name: 'Cameroun', dial: '+237' },
  { code: 'GA', name: 'Gabon', dial: '+241' },
  { code: 'CG', name: 'Congo', dial: '+242' },
  { code: 'CD', name: 'RD Congo', dial: '+243' },
  { code: 'MA', name: 'Maroc', dial: '+212' },
  { code: 'DZ', name: 'Algérie', dial: '+213' },
  { code: 'TN', name: 'Tunisie', dial: '+216' },
  { code: 'NG', name: 'Nigeria', dial: '+234' },
  { code: 'GH', name: 'Ghana', dial: '+233' },
  { code: 'ZA', name: 'Afrique du Sud', dial: '+27' },
  { code: 'AE', name: 'Émirats arabes unis', dial: '+971' },
  { code: 'CN', name: 'Chine', dial: '+86' },
];

export const DEFAULT_PHONE_COUNTRY = 'FR';
